import React, { useContext } from "react";
import "../account.css";
import "./accountLanguage.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import ReactCountryFlag from "react-country-flag";
import { Check } from "lucide-react";

const LANGUAGES = [
    { code: "en", country: "CA", label: "English", hintKey: "englishHint" },
    { code: "es", country: "DO", label: "Español", hintKey: "spanishHint" },
];

const AccountLanguage = () => {
    const { language, setLanguage } = useContext(CombinedContext);
    const t = translations[language].account.language;

    return (
        <div className="ac-page apl">
            <header className="ac-head">
                {/* <span className="ac-eyebrow">{translations[language].account.menu?.language || "Language"}</span> */}
                <h1 className="ac-title">{t.title}</h1>
                {t.subtitle && <p className="ac-sub">{t.subtitle}</p>}
            </header>

            <div className="ac-options">
                {LANGUAGES.map((lang) => (
                    <button
                        key={lang.code}
                        className={`ac-option ${language === lang.code ? "is-active" : ""}`}
                        onClick={() => setLanguage(lang.code)}
                    >
                        <span className="apl-flag">
                            <ReactCountryFlag countryCode={lang.country} svg />
                        </span>

                        <span className="ac-option-copy">
                            <span className="ac-option-label">{lang.label}</span>
                            {t[lang.hintKey] && <span className="ac-option-hint">{t[lang.hintKey]}</span>}
                        </span>

                        <span className="ac-option-check">
                            <Check size={13} strokeWidth={3} />
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AccountLanguage;
